import { render, staticRenderFns } from "./FloatingLabel.vue?vue&type=template&id=58e61d66"
import script from "./FloatingLabel.vue?vue&type=script&lang=ts"
export * from "./FloatingLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports